var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-badge',{staticClass:"mx-3",attrs:{"bordered":"","bottom":"","dot":"","offset-x":"10","offset-y":"10","color":`${ _vm.state ? 'success' : 'error'}`}},[_c('v-avatar',{attrs:{"size":"32"}},[_c('v-img',{attrs:{"src":`marketplaces/${ _vm.marketplace }.png`,"alt":_vm.marketplace}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }